import React from 'react';
import Field from '@cpg-its/ads.form.field';
import { FormikProps } from 'formik';
import {  makeStyles } from '@material-ui/core';
import { countryPhoneCodes } from '../../constants/lists';
import { UnitedStatesCountryCode } from '../../../pages/arc/constants/constant-strings';


const useStyles = makeStyles((theme) => ({
    phoneFieldWrapper: {
        display: 'flex',
        alignItems: 'flex-end',
        marginTop: theme.spacing(.5),
        '&.extension-error': {
            alignItems: 'flex-start',
        },
        '& .phone-field': {
            flex: '1 1 auto',
            '&.extension-error': { // adds padding to offset error styles
                
                paddingTop: theme.spacing(1.5),
            },
            '&-extension': {
                width: '25%',
                marginLeft: theme.spacing(.5),
            },
        },
    },


}));



interface PhoneFieldProps {
    label: string,
    extLabel?: string,
    countryFieldName: string,
    phoneFieldName: string,
    extFieldName?: string
    ext: boolean,
    formProps: FormikProps<any>,
    required?: boolean,
}

export function PhoneField(props: PhoneFieldProps) {
    const classes = useStyles();
    const currentCountryCode = props.formProps.values[props.countryFieldName];
    return (
        <div className='form-item'>
            <Field
                name={props.countryFieldName}
                label={props.label}
                component='input'
                options={countryPhoneCodes}               
                select
                required={props.required}
            />

            <div className={`${classes.phoneFieldWrapper} ${props.ext && props.formProps.errors[props.phoneFieldName] ? 'extension-error' : ''}`}>
                <div className={`phone-field ${props.ext && props.formProps.errors[props.phoneFieldName] ? 'extension-error' : ''} `}>
                    <Field
                        name={props.phoneFieldName}
                        component='input'                       
                        mask={currentCountryCode === UnitedStatesCountryCode ?
                            ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
                            : null}
                    /></div>

                {
                    props.ext ?
                        <div className='phone-field-extension'>
                            <Field
                                name={props.extFieldName}
                                label={props.extLabel}
                                component='input'                              
                            />
                        </div>
                        : null
                }
            </div>
        </div>
    );
}
PhoneField.defaultProps = {
    extLabel: 'Ext.',
    extFieldName: '',
    required: false,
};